module.exports = __webpack_public_path__ + "img/skull_bj.f858813d.png";